import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'moment/locale/zh-cn';
import '@ud/admin-framework/lib/theme/aliyun-v1.less';
import { uaaCenter, IUaaCenterOptions } from './uaaCenter';
import App from './App';
import { http, udConfigProvider } from '@ud/admin-framework';

moment.locale('zh-cn');

// warn: 如果要修改这里的接口地址，也需要同步修改 ../scripts/build.js 文件中的相关接口地址。不然编译发布后会导致严重的后果。
let baseURL = '';
console.log('process.env.REACT_APP_ENV: ', process.env.REACT_APP_ENV);
if (process.env.REACT_APP_ENV === 'dev') {
  baseURL = 'http://10.4.100.120:25110';
} else if (process.env.REACT_APP_ENV === 'local2') {
  baseURL = 'https://gateway-uaa-test2.19k8s.cn';
} else if (process.env.REACT_APP_ENV === 'test') {
  // baseURL = 'https://uaa-gateway-test.1919.cn'
  baseURL = 'https://uaa-gateway-test.19k8s.cn';
} else if (process.env.REACT_APP_ENV === 'test2') {
  baseURL = 'https://gateway-uaa-test2.19k8s.cn';
} else if (process.env.REACT_APP_ENV === 'prod') {
  baseURL = 'https://uaa-gateway.1919.cn';
} else {
  // baseURL = 'http://10.10.10.137:25110'
  // baseURL = '/'
  baseURL = 'https://uaa-gateway-test.19k8s.cn';
}

let DEVICE_ID: any = '';
if (localStorage.getItem('DEVICE_ID')) {
  DEVICE_ID = localStorage.getItem('DEVICE_ID');
} else {
  DEVICE_ID = '' + (Math.random() * 10000).toFixed(0) + new Date().valueOf();
  localStorage.setItem('DEVICE_ID', DEVICE_ID);
}

udConfigProvider.http.requestBefore = (config) => {
  console.log(config, 'sssssssssssssssssssss')
  config.headers = { ...config.headers, deviceid: DEVICE_ID };
  return config;
};

// http.defaults.withCredentials = true

let options: IUaaCenterOptions = {
  baseURL: baseURL,
  render: () => {
    ReactDOM.render(<App />, document.getElementById('root'));
  },
};

uaaCenter.run(options);
